import { Button, Col, Form, Row, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import FileSaver from "file-saver";
// import {
//   importFile,
//   downloadImportFile,
// } from "../../services/importFileService";
import WithSidebar from "../../templates/withSidebar";
import { UploadOutlined } from "@ant-design/icons";
import React from "react";
import SuccessModal from "../../components/modal/successModal";
import FailModal from "../../components/modal/failModal";
import useListFileExport from "../../lib/hooks/useListFileExport";
import { exportReportFile } from "../../services/exportService";
// import { useDropzone } from "react-dropzone";

const Option = Select.Option;
const { Title } = Typography;

const ExportFile = () => {
  const [form] = Form.useForm();
  const [listFileExport] = useListFileExport();
  const [type, setType] = useState("");

  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [failTitle, setFailTitle] = useState("");
  const [failSubtitle, setFailSubtitle] = useState("");
  const [hideYearOfBudget, setHideYearOfBudget] = useState(false);

  const [dataShow, setDataShow] = useState([]);

  // const onDrop = async (acceptedFiles) => {
  //   if (acceptedFiles[0] === undefined) {
  //     setFailModal(true);
  //     setFailTitle("นำเข้าไม่สำเร็จ");
  //     setFailSubtitle("นำเข้าไฟล์เกิน 1 ไฟล์");
  //   } else if (acceptedFiles[0].size > 10485760) {
  //     setFailModal(true);
  //     setFailTitle("นำเข้าไม่สำเร็จ");
  //     setFailSubtitle("ขนาดไฟล์เกิน 10 MB");
  //   } else if (
  //     acceptedFiles[0].name.includes(".xlsx") === false &&
  //     acceptedFiles[0].name.includes(".xls") === false
  //   ) {
  //     setFailModal(true);
  //     setFailTitle("นำเข้าไม่สำเร็จ");
  //     setFailSubtitle("รองรับนามสกุล .xlsx เท่านั้น");
  //   } else if (type === "") {
  //     setFailModal(true);
  //     setFailTitle("นำเข้าไม่สำเร็จ");
  //     setFailSubtitle("กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล");
  //   } else if (
  //     type === "customerInEstate" &&
  //     acceptedFiles[0].name !== "Customer_in_the_estate.xlsx"
  //   ) {
  //     setFailModal(true);
  //     setFailTitle("นำเข้าไม่สำเร็จ");
  //     setFailSubtitle("กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล");
  //   } else if (
  //     type === "formerCustomer" &&
  //     acceptedFiles[0].name !== "Former_Customer.xlsx"
  //   ) {
  //     setFailModal(true);
  //     setFailTitle("นำเข้าไม่สำเร็จ");
  //     setFailSubtitle("กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล");
  //   } else if (
  //     type === "futureCustomer" &&
  //     acceptedFiles[0].name !== "Future_Customer.xlsx"
  //   ) {
  //     setFailModal(true);
  //     setFailTitle("นำเข้าไม่สำเร็จ");
  //     setFailSubtitle("กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล");
  //   } else {
  //     const formData = new FormData();

  //     formData.append("file", acceptedFiles[0]);
  //     formData.append("template", type);

  //     const res = await importFile(formData);
  //     setDataShow(res);
  //     setSuccessModal(true);
  //   }
  // };

  // const { getRootProps, getInputProps } = useDropzone({
  //   onDrop,
  //   multiple: false,
  // });

  // const downloadFile = useCallback(async (fileName) => {
  //   const res = await downloadImportFile(fileName);
  //   let link = document.createElement("a");
  //   link.href = window.URL.createObjectURL(
  //     new Blob([res.data], { type: "application/vnd.ms-excel" })
  //   );
  //   link.download = fileName;
  //   link.click();
  // }, []);

  useEffect(() => {}, []);

  // const list = [
  //   {
  //     value: "1",
  //     name: "รายงานข้อมูลพื้นฐานบริษัท",
  //   },
  //   {
  //     value: "2",
  //     name: "รายงานข้อมูลการเยี่ยมพบ (Customer Visit)",
  //   },
  //   {
  //     value: "3",
  //     name: "รายงานข้อมูลการใช้น้ํา",
  //   },
  //   {
  //     value: "4",
  //     name: "รายงานข้อมูล Touch Point",
  //   },
  //   {
  //     value: "5",
  //     name: "รายงานข้อมูลลูกค้าอนาคต",
  //   },
  //   {
  //     value: "6",
  //     name: "รายงานข้อมูลหน่วยงานผู้มีส่วนได้ส่วนเสีย",
  //   },
  // ];

  const startYear = 2016;
  const endYear = new Date().getFullYear() + 3;
  const allYearValues = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => (endYear - i) + 543
  );

  // on export button clicked
  const onExport = async () => {
    try {
      const values = await form.validateFields(
        hideYearOfBudget ? ["exportName"] : ["exportName", "yearOfBudget"]
      );
      const payload = {
        ...values,
        yearOfBudget: values.exportName === "competitor"
          ? [new Date().getFullYear()]
          : values.yearOfBudget,
      };
      const res = await exportReportFile(payload);
      const contentType = res.headers?.["content-type"] || "";
      if (res.status !== 200 || !contentType.includes("spreadsheetml.sheet")) {
        throw new Error("ไม่ได้รับไฟล์ Excel จากระบบ");
      }
      const config = listFileExport.find(item => item.exportName === values.exportName);
      FileSaver.saveAs(new Blob([res.data], { type: contentType }),
        `${config?.exportOutputFileName || "exported-file"}.xlsx`);
      setSuccessModal(true);
    } catch (error) {
      if (error.errorFields) return; // Ant Design displays field validation messages.
      setFailTitle("นำออกไม่สำเร็จ");
      setFailSubtitle("ไม่สามารถสร้างไฟล์ได้ กรุณาตรวจสอบข้อมูลหรือติดต่อผู้ดูแลระบบ");
      setFailModal(true);
    }
  };

  const handleYearChange = (selectedValue) => {
    if (selectedValue.includes("all")) {
      // ถ้ามี "all" ให้ใช้ form.setFieldsValue เพื่อเซ็ตค่าให้เป็นปีทั้งหมด
      form.setFieldsValue({
        yearOfBudget: allYearValues,
      });
    } else {
      // ถ้าไม่มี ก็ให้เซ็ตค่าตามที่ผู้ใช้เลือกตามปกติ
      form.setFieldsValue({
        yearOfBudget: selectedValue,
      });
    }
  };

  return (
    <WithSidebar>
      <Row gutter={[16]}>
        <Col span={24}>
          <div className="flex justify-between items-center">
            <Title level={4} style={{ marginTop: 25 }}>
              นำออกข้อมูล
            </Title>
          </div>
        </Col>
      </Row>

      <div style={{ margin: "40px 300px" }}>
        <Form
          form={form}
          name="validateOnly"
          layout="vertical"
          autoComplete="off"
        >
          <Row gutter={[24, 16]} style={{ marginBottom: 25 }}>
            <Col span={24}>
              <Form.Item
                label="ประเภทแบบฟอร์มที่นำออกข้อมูล"
                name={"exportName"}
                rules={[
                  {
                    required: type === "" ? true : false,
                    message: "กรุณาระบุประเภทแบบฟอร์มที่นำออกข้อมูล",
                  },
                ]}
              >
                <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="กรุณาเลือก"
                  onSelect={(value) => {

                    if(value === "competitor"){
                      setHideYearOfBudget(true);
                    }else {
                      setHideYearOfBudget(false);
                    }
                  }}
                >
                  {/* {list.map((item, i) => (
                    <Option key={i} value={item.dataId}>
                      {item.name}
                    </Option>
                  ))} */}

                  {listFileExport.map((item) => (
                    <Option key={item.exportId} value={item.exportName}>
                      {item.exportDisplayNameTh}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[24, 16]} style={{ marginBottom: 25 }}>
            <Col span={24}>
              <Form.Item
                hidden={hideYearOfBudget}
                label="ปีงบประมาณ"
                name={["yearOfBudget"]}
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="กรุณาเลือก"
                  mode={"multiple"}
                  maxTagCount={"responsive"}
                  onChange={handleYearChange}
                >
                  <Option key={"all"} value={"all"}>
                    เลือกทั้งหมด
                  </Option>
                  {allYearValues.map((year) => (
                    <Option key={year} value={year}>
                      {year}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Button
          // type="primary"
          // style={{ width: "100%" }}
          onClick={onExport}
        >
          <UploadOutlined /> นำข้อมูลออก
        </Button>
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        open={failModal}
        setOpen={setFailModal}
        title={failTitle}
        subTitle={failSubtitle}
      />
    </WithSidebar>
  );
};

export default ExportFile;
